import { Query, UserMfaPreference } from 'graphql/generated/graphqlTypes';

export function getMfaPreferenceDataForQuery(getMfaPreference: UserMfaPreference): Pick<Query, 'getMfaPreference'> {
  return {
    getMfaPreference
  };
}

export const mockedGetMfaPreferenceDataForQuery = getMfaPreferenceDataForQuery({
  emailMfaEnabled: true,
  __typename: 'UserMfaPreference'
});
